/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { NewTransactionResponse } from "./NewTransactionResponse";
import { TransactionStatus } from "./TransactionStatus";

/**
 * Transaction data returned when querying for an existing transaction
 */

// required attributes
const TransactionInfo2R = t.interface({
  status: TransactionStatus
});

// optional attributes
const TransactionInfo2O = t.partial({
  gatewayAuthorizationStatus: t.string
});

export const TransactionInfo2 = t.intersection(
  [TransactionInfo2R, TransactionInfo2O],
  "TransactionInfo2"
);

export type TransactionInfo2 = t.TypeOf<typeof TransactionInfo2>;

export const TransactionInfo = t.intersection(
  [NewTransactionResponse, TransactionInfo2],
  "TransactionInfo"
);

export type TransactionInfo = t.TypeOf<typeof TransactionInfo>;
